import { render, staticRenderFns } from "./TableSalePlan.vue?vue&type=template&id=ce2a9658&scoped=true&lang=pug&"
import script from "./TableSalePlan.vue?vue&type=script&lang=js&"
export * from "./TableSalePlan.vue?vue&type=script&lang=js&"
import style0 from "./TableSalePlan.vue?vue&type=style&index=0&id=ce2a9658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2a9658",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VPagination,VSimpleTable})
